export default function getCroppedImg(imageSrc, cropPixels, maxSize = 1000) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const canvas = document.createElement("canvas");
      let { width, height } = cropPixels;
      let scale = 1;
      if (Math.max(width, height) > maxSize) {
        scale = maxSize / Math.max(width, height);
      }
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round(height * scale);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        cropPixels.x, cropPixels.y, width, height,
        0, 0, canvas.width, canvas.height
      );
      canvas.toBlob(
        (blob) => {
          if (!blob) return reject(new Error("Crop failed"));
          resolve(blob);
        },
        "image/jpeg",
        0.9
      );
    };
    image.onerror = reject;
    image.src = imageSrc;
  });
}
